import { UseStore } from '@eastcoal/common/types/zustand'
import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { ContractDesignerContext } from '../contexts/StoreContext'
import { ContractDesignerStore } from '../store/interface'

export const useContractDesignerStore: UseStore<
  ContractDesignerStore
> = selector => {
  return useContextStore(ContractDesignerContext, selector)
}

export const useContractDesignerStoreApi = () => {
  return useContextStoreApi(ContractDesignerContext)
}
